<template>
  <v-container>
    <v-toolbar flat class="mt-3">
      <v-toolbar-title style="font-weight: bold">{{
        $t("Subinventory")
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-col cols="12" md="2">
        <v-btn
          :disabled="InvalidFilter"
          @click="handlePopulate"
          large
          block
          class="primary"
          rounded
          >{{ $t("button.populate") }}</v-btn
        >
      </v-col>
    </v-toolbar>
    <form-wrapper :validator="$v.form">
      <v-row class="mt-5">
        <v-col cols="12" :md="items.length > 0 ? 8 : 12" class="py-0">
          <v-autocomplete
            @change="handleFilter('transaction_type_id', form.transaction_type)"
            v-model="form.transaction_type"
            :items="transactionTypes"
            item-text="name"
            item-value="id"
            :label="$t('Transaction Type')"
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="4" class="py-0" v-if="items.length > 0">
          <v-menu
            ref="transactionsFromDateMenu"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <form-group name="date">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.date"
                    v-bind="attrs"
                    :label="$t('date_and_time')"
                    color="primary"
                    v-on="on"
                    clearable
                    outlined
                    @blur="$v.form.date.$touch()"
                  ></v-text-field>
                </template>
              </form-group>
            </template>
            <v-date-picker no-title v-model="form.date"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="6" class="py-0">
          <v-autocomplete
            @change="handleFilter('inventory', form.inventory)"
            :disabled="form.transaction_type === ''"
            v-model="form.inventory"
            :items="inventories"
            item-text="name"
            item-value="id"
            :label="labelText"
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6" class="py-0" v-if="showLocator">
          <v-autocomplete
            @change="handleFilter('locator_id', form.locator)"
            :disabled="locatorItems.length === 0"
            :items="locatorItems"
            item-text="name"
            item-value="id"
            v-model="form.locator"
            :label="need_two_inventories ? $t('From Locator') : $t('Locator')"
            outlined
            :loading="loadingLocator"
          ></v-autocomplete>
        </v-col>
        <v-col v-if="need_two_inventories" cols="12" md="6" class="py-0">
          <form-group name="to_inventory" :attribute="$t('field.to_inventory')">
            <template slot-scope="{ attrs, listeners }">
              <v-autocomplete
                v-bind="attrs"
                v-on="listeners"
                :items="to_inventories"
                item-text="name"
                item-value="id"
                item-disabled="item_disabled"
                v-model="form.to_inventory"
                :label="$t('To Subinventory')"
                outlined
              ></v-autocomplete>
            </template>
          </form-group>
        </v-col>
        <template v-if="need_two_inventories">
          <v-col v-if="showToLocator" cols="12" md="6" class="py-0">
            <form-group name="to_locator" :attribute="$t('field.to_locator')">
              <template slot-scope="{ attrs, listeners }">
                <v-autocomplete
                  v-bind="attrs"
                  v-on="listeners"
                  :disabled="
                    form.to_inventory === '' || tolocatorItems.length === 0
                  "
                  :items="tolocatorItems"
                  item-text="name"
                  item-value="id"
                  v-model="form.to_locator"
                  :label="$t('to Locator')"
                  outlined
                  :loading="loadingToLocator"
                ></v-autocomplete>
              </template>
            </form-group>
          </v-col>
        </template>

        <v-col cols="12" md="8" class="py-0" v-if="items.length > 0">
          <v-text-field
            v-model="form.description"
            :label="$t('description')"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="py-0" v-if="items.length > 0">
          <v-text-field
            v-model="form.reference_number"
            :label="$t('Refrence Number')"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
    </form-wrapper>
    <template v-if="items.length > 0">
      <ItemsTable
        :form="form"
        :items="items"
        :pagination="pagination"
        @on-refresh-items="resetData"
        :v="$v"
      />
    </template>
  </v-container>
</template>

<script>
import { IndexData } from "@/helpers/apiMethods";
import { required, requiredIf } from "vuelidate/lib/validators";
export default {
  name: "BulkTransaction",
  components: {
    ItemsTable: () => import("./components/ItemsTable"),
  },
  data() {
    return {
      inventories: [],
      to_inventories: [],
      transactionTypes: [],
      form: {
        reference_number: "",
        date: "",
        description: "",
        inventory: "",
        to_inventory: "",
        locator: "",
        to_locator: "",
        reference_number: "",
        transaction_type: "",
        locator_type: "",
        to_locator_type: "",
      },
      need_two_inventories: false,
      locatorItems: [],
      tolocatorItems: [],
      showLocator: true,
      showToLocator: true,
      reqType: "camps",
      toLocatorReqType: "camps",
      loadingLocator: false,
      loadingToLocator: false,
      items: [],
      queries: {},
      foundInventor: { for_camps: "", for_employees: "" },
    };
  },
  methods: {
    resetData() {
      this.items = [];
      this.$v.form.$reset();
      for (const key in this.form) {
        this.form[key] = "";
      }
    },
    handlePopulate(query = this.queries) {
      const queryString = { ...this.$route.query, ...this.queries };
      if (
        this.foundInventor.for_camps === 0 &&
        this.foundInventor.for_employees === 0
      ) {
        delete queryString.locator_type;
      }
      if (!this.showLocator) {
        delete queryString.locator_id;
      }
      this.$router.push({ query: { ...queryString } });
      IndexData({
        reqName: "scm/on-hands",
        query: { ...this.$route.query, ...query, without_zero: "yes" },
      }).then((res) => {
        const { data, meta } = res.data;
        this.items = data.map((el) => ({
          ...el.item,
          max_on_hande: el.on_hand_qty,
        }));
        setTimeout(() => {
          this.form.inventory = data[0].inventory.id;
        }, 1000);
        this.pagination = meta;

        setTimeout(() => {
          if (
            this.$route.query.locator_id ||
            this.$route.query.transaction_type_id
          ) {
            this.form.transaction_type = Number(
              this.$route.query.transaction_type_id
            );
            this.form.locator = Number(
              this.$route.query.locator_id ? this.$route.query.locator_id : ""
            );
          }
        }, 1000);
      });
    },
    handleFilter(key, value) {
      this.queries[key] = value;
    },
    async getInitialData() {
      const [inventoriesRes, typeRes] = await Promise.all([
        IndexData({ reqName: "scm/inventories" }),
        IndexData({ reqName: "scm/transaction-types" }),
      ]);
      this.inventories = inventoriesRes.data.data;
      this.to_inventories = this.inventories.map((el) => {
        return {
          ...el,
          item_disabled: false,
        };
      });
      this.transactionTypes = typeRes.data.data;
    },
    handleLocator(reqName = this.reqType) {
      this.loadingLocator = true;
      IndexData({
        reqName: `scm/${reqName}`,
        query: { pagination: "all" },
      }).then((res) => {
        const { data } = res.data;
        this.locatorItems = data;
        this.loadingLocator = false;
      });
    },
    hadleToLocator(reqName = this.toLocatorReqType) {
      this.loadingToLocator = true;
      IndexData({
        reqName: `scm/${reqName}`,
        query: { pagination: "all" },
      }).then((res) => {
        const { data } = res.data;
        this.tolocatorItems = data;
        this.loadingToLocator = false;
      });
    },
  },
  computed: {
    labelText() {
      if (!this.need_two_inventories) {
        return this.$t("Subinventory");
      } else {
        return this.$t("From Subinventory");
      }
    },
    InvalidFilter() {
      if (this.form.inventory === "") {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    showLocator: {
      handler(value) {
        if (!value) {
          this.form.to_locator = "";
        }
      },
      immediate: true,
    },
    need_two_inventories: {
      handler(value) {
        if (!value) {
          this.form.to_inventory = "";
        }
      },
      immediate: true,
    },
    $route: {
      handler({ query }) {
        if (query.locator_id || query.transaction_type_id) {
          this.handlePopulate(query);
        }
        this.getInitialData();
      },
      immediate: true,
    },
    "form.transaction_type": {
      handler(transaction_type) {
        if (transaction_type) {
          const selectedType = this.transactionTypes.find(
            (type) => type.id === this.form.transaction_type
          );
          this.need_two_inventories = selectedType.need_two_inventories;
        }
      },
      immediate: true,
    },
    "form.inventory": {
      handler(inventory) {
        this.foundInventor = { for_camps: "", for_employees: "" };
        if (inventory) {
          this.foundInventor = this.inventories.find(
            (inventor) => inventor.id === this.form.inventory
          );
          if (
            this.foundInventor.for_camps === 1 &&
            this.foundInventor.for_employees === 0
          ) {
            this.reqType = "camps";

            this.handleLocator(this.reqType);
            this.form.locator_type = this.reqType.substring(
              0,
              this.reqType.length - 1
            );
          } else {
            this.reqType = "employees";
            this.handleLocator(this.reqType);
          }
          this.handleFilter(
            "locator_type",
            this.reqType.substring(0, this.reqType.length - 1)
          );
          if (
            this.foundInventor.for_camps === 0 &&
            this.foundInventor.for_employees === 0
          ) {
            this.showLocator = false;
            this.handleFilter("locator_type", "");
            this.form.locator_type = "";
            this.form.locator = "";
          } else {
            this.showLocator = true;
          }
        }
        this.to_inventories = this.to_inventories.map((el) => {
          if (
            this.foundInventor.for_camps === 0 &&
            this.foundInventor.for_employees === 0 &&
            el.id === inventory
          ) {
            return {
              ...el,
              item_disabled: true,
            };
          } else {
            return {
              ...el,
              item_disabled: false,
            };
          }
        });
      },
      immediate: true,
    },
    "form.to_inventory": {
      handler(value) {
        let founded = { for_camps: "", for_employees: "" };
        if (value) {
          founded = this.inventories.find((inventor) => inventor.id === value);
          if (founded.for_camps === 1 && founded.for_employees === 0) {
            this.toLocatorReqType = "camps";
            this.hadleToLocator(this.toLocatorReqType);
          } else {
            this.toLocatorReqType = "employees";
            this.hadleToLocator(this.toLocatorReqType);
          }
          this.form.to_locator_type = this.toLocatorReqType.substring(
            0,
            this.toLocatorReqType.length - 1
          );
        }
        if (this.need_two_inventories) {
          if (founded.for_camps === 0 && founded.for_employees === 0) {
            this.showToLocator = false;
            this.form.to_locator = "";
            this.form.to_locator_type = "";
          } else {
            this.showToLocator = true;
          }
        }
      },
      immediate: true,
    },
  },
  validations() {
    return {
      form: {
        date: {
          required,
        },
        to_inventory: {
          required: requiredIf(function () {
            if (this.need_two_inventories) {
              return true;
            }
          }),
        },
        to_locator: {
          required: requiredIf(function () {
            if (this.showToLocator && this.need_two_inventories) {
              return true;
            } else {
              return false;
            }
          }),
        },
      },
    };
  },
};
</script>

